<template>
  <v-card class="mb-6" max-width="1000" :rounded="false" outlined>
    <v-container fluid class="pa-0">
      <v-file-input
        v-if="value === null"
        prepend-icon=""
        prepend-inner-icon="$file"
        chips
        :label="label"
        :truncate-length="100"
        ref="fileinput"
        @change="setLocalPreview($event)"
        :disabled="disabled"
        :rules="enhancedRules"
        filled
        show-size
      >
      </v-file-input>
      <v-toolbar v-else color="blue-grey lighten-1" dark flat>
        <v-toolbar-title>{{ filename }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="detachFileDialog = true">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-toolbar>
      <div v-if="loading" class="pt-10 pb-10 px-10 text-center">
        <v-progress-circular size="30" width="2" indeterminate color="grey" class="py-10"></v-progress-circular>
      </div>
      <div v-else>
        <!-- refs are not working properly with v-if, so hide it via css -->
        <div :class="['pt-5', 'pb-10', 'px-10', url ? 'd-block' : 'd-none']">
          <v-menu absolute offset-y>
            <v-list v-if="!localPreview">
              <v-list-item @click="download()">
                <v-list-item-title>
                  {{ $t('image.download') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <template v-slot:activator="{ on, attrs }">
              <a :href="url">Download File ({{filename}})</a>
            </template>
          </v-menu>
        </div>
        <!-- refs are not working properly with v-if, so hide it via css -->
        <div :class="['text-caption', 'text-center', !url ? 'd-block' : 'd-none']">
          <v-icon size="100" color="blue-grey lighten-2">mdi-file</v-icon>
          <p>{{ $t('attachment.selectFile') }}</p>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="detachFileDialog" persistent width="500">
      <v-card v-if="valueVariationsToDelete.length">
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-toolbar-title>Detach File</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5">
          <v-chip v-for="(variation, index) in valueVariationsToDelete" :key="index" class="ma-2">
            <v-icon left v-if="deletedVariationFragments.indexOf(variation) !== -1" color="success"> mdi-check </v-icon>
            <v-progress-circular
              v-else
              size="15"
              width="2"
              indeterminate
              color="grey"
              class="mr-2"
            ></v-progress-circular>
            {{ variation }}
          </v-chip>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-toolbar-title>{{ $t('attachment.detach') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5">
          {{ $t('attachment.detachDetails') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="detachFileDialog = false">{{ $t('cta.cancel') }}</v-btn>
          <v-btn color="warning" @click="detachFiles">{{ $t('cta.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';
import attachmentMixin from '@/mixins/LeanAttachment';

export default {
  name: 'LeanFile',
  mixins: [fieldMixin, attachmentMixin],
  methods: {}
};
</script>
